var map = {
	"./freyung-grafenau/RegionCenter": [
		1625,
		514
	],
	"./inn-salzach/RegionCenter": [
		1626,
		527
	],
	"./passau/RegionCenter": [
		1627,
		506
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1263;
module.exports = webpackAsyncContext;